import { capitalizeAll } from 'services/Utils';

export const getLanguageDisplayName = (languageCode: string, destinationLanguageCode = ''): string => {
  const normalized = languageCode.replaceAll('_', '-');
  const destination = destinationLanguageCode || normalized;
  const normalizedDestination = destination.replaceAll('_', '-');

  try {
    const displayNames = new Intl.DisplayNames([normalizedDestination], { type: 'language' });
    return capitalizeAll(displayNames.of(normalized) ?? languageCode);
  } catch {
    return languageCode;
  }
};
